<template>
	<div class="detail-page">
		<div>
			<van-nav-bar :title="data.xuanfei_name" left-arrow @click-left="onClickLeft">
				<template #left>
					<van-icon name="arrow-left" size="22" color="#fff" />
				</template>
			</van-nav-bar>
		</div>
		<div class="feiziInfo">
			<div class="topInfo">
				<div class="top-main">
					<div class="top-left">
						<h1 class="name">{{ data.xuanfei_name }}</h1>
						<p class="meta">
							{{$t("index.height")}}:{{ data.hight }}
							<span class="meta-gap">{{$t("index.bust")}}：{{ data.bust }}</span>
						</p>
						<div class="tags">
							<span class="item" v-for="(item,index) in data.flagArray" :key="index">{{item}}</span>
						</div>
						<div class="rate-row">
							<span class="label">{{$t("index.toll")}}：</span>
							<van-rate v-model="data.number" readonly color="#ffd21e" size="18px" />
						</div>
						<p class="address">
							{{$t("index.residence")}}：{{ data.address }}
						</p>
					</div>
					<div class="top-right">
						<button type="button" class="like-btn" :class="{ liked: isPraised }" @click="clickPraise">
							<img src="/img/zan.c28032c8.png" alt="" />
						</button>
						<p class="like-count">{{ data.dianzan }}</p>
					</div>
				</div>
				<button type="button" class="yuyueBox" @click="getUserGameList">{{$t("index.instant_booking")}}</button>
			</div>

			<div class="previewInfo" v-if="previewUrls.length">
				<div
					class="preview-item"
					v-for="(url, index) in previewUrls"
					:key="index"
				>
					<img :src="url" alt="" class="preview-img" />
				</div>
			</div>

			<div class="btmInfo">
				<div class="section-title">{{$t('index.personal_profile')}}</div>
				<div class="section-body">{{ data.jianjie }}</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				data: {},
				isPraised: false,
			};
		},
		computed: {
			// img_url[0] 为封面（列表用），详情只展示预览图 img_url[1..]
			previewUrls() {
				const img = this.data && this.data.img_url;
				if (!img) return [];
				if (Array.isArray(img)) return img.slice(1).filter(Boolean);
				return [];
			},
		},
		methods: {
			getxuanfeidata() {
				this.$http({
					method: 'get',
					url: 'xuanfeidata',
					data: {
						id: this.$route.query.id
					}
				}).then(res => {
					this.data = res.data;
					const lanng = localStorage.getItem("lang");
					const parts = this.data.flag.split('|')
					lanng == 'zh' ? this.data.flag = parts[0] : lanng == 'en' ? this.data.flag = parts[1] :
						lanng == 'ja' ? this.data.flag = parts[2] : this.data.flag = parts[3]
					this.data.flagArray = this.data.flag.split('，');
				});
			},
			onClickLeft() {
				this.$router.go(-1)
			},
			clickPraise() {
				if (this.isPraised) {
					this.data.dianzan--;
					this.isPraised = false;
				} else {
					this.data.dianzan++;
					this.isPraised = true;
				}
			},
			getUserGameList() {
				this.$http({
					method: 'get',
					url: 'user_get_game_list'
				}).then(res => {
					if (res.code === 200) {
						this.$toast('먼저 활성화 작업을 완료하십시오.');
						this.list = res.data;
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				})
			}
		},
		created() {
			this.getxuanfeidata();
		},
	};
</script>

<style scoped lang="less">
	.detail-page {
		min-height: 100vh;
		width: 100%;
		max-width: 100vw;
		overflow-x: hidden;
		box-sizing: border-box;
		background: #f3f0f7;
	}

	.van-nav-bar {
		background: linear-gradient(90deg, #8b7cf0, #e85a9a) !important;
	}

	.van-nav-bar .van-icon {
		color: #fff !important;
	}

	.feiziInfo {
		padding: 3.2vw 3.6vw 6vw;
		width: 100%;
		max-width: 100%;
		box-sizing: border-box;
		overflow-x: hidden;
	}

	.topInfo {
		position: relative;
		padding: 5.5vw 4.5vw 5vw;
		background: #fff;
		border-radius: 4.2vw;
		box-shadow: 0 10px 28px rgba(79, 43, 138, 0.14), 0 4px 12px rgba(0, 0, 0, 0.06);
		overflow: hidden;
	}

	.topInfo::before {
		content: "";
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		height: 1.2vw;
		background: linear-gradient(90deg, #8b7cf0, #e85a9a);
	}

	.top-main {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		gap: 3vw;
	}

	.top-left {
		flex: 1;
		min-width: 0;
	}

	.name {
		margin: 0;
		color: #2a1468;
		font-size: 6.2vw;
		font-weight: 700;
		line-height: 1.25;
		letter-spacing: 0.02em;
	}

	.meta {
		margin: 2.2vw 0 0;
		color: #7a4bb8;
		font-size: 3.4vw;
		line-height: 1.4;
	}

	.meta-gap {
		margin-left: 2.4vw;
	}

	.tags {
		display: flex;
		flex-wrap: wrap;
		gap: 2vw;
		margin-top: 3.2vw;
	}

	.topInfo .item {
		background: linear-gradient(120deg, #a15fd4, #e85a9a);
		color: #fff;
		display: inline-block;
		border-radius: 999px;
		font-size: 3vw;
		padding: 1.4vw 3.2vw;
		line-height: 1.3;
		box-shadow: 0 4px 10px rgba(198, 74, 140, 0.22);
	}

	.rate-row {
		display: flex;
		align-items: center;
		margin-top: 3.4vw;
	}

	.rate-row .label,
	.address {
		color: #6b22b3;
		font-size: 3.5vw;
	}

	.address {
		margin: 2vw 0 0;
		line-height: 1.4;
		word-break: break-all;
	}

	.top-right {
		display: flex;
		flex-direction: column;
		align-items: center;
		flex-shrink: 0;
		padding-top: 0.5vw;
	}

	.like-btn {
		width: 14vw;
		height: 14vw;
		border: 0;
		padding: 0;
		border-radius: 50%;
		background: transparent;
		display: flex;
		align-items: center;
		justify-content: center;
		box-shadow: 0 8px 18px rgba(76, 175, 80, 0.28);
		transition: transform 0.15s ease;
	}

	.like-btn.liked {
		transform: scale(1.06);
	}

	.like-btn img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: 50%;
	}

	.like-count {
		margin: 1.6vw 0 0;
		color: #7a4bb8;
		font-size: 3.6vw;
		font-weight: 600;
	}

	.yuyueBox {
		display: block;
		width: 100%;
		margin-top: 5vw;
		border: 0;
		color: #fff;
		font-size: 4vw;
		font-weight: 600;
		letter-spacing: 0.04em;
		padding: 3.2vw 0;
		background: linear-gradient(100deg, #e73266, #f06a98);
		border-radius: 999px;
		box-shadow: 0 8px 20px rgba(231, 50, 102, 0.28);
		text-align: center;
	}

	.previewInfo {
		margin-top: 3.2vw;
		width: 100%;
		max-width: 100%;
		box-sizing: border-box;
		padding: 2.4vw;
		background: #fff;
		border-radius: 4.2vw;
		overflow: hidden;
		box-shadow: 0 10px 28px rgba(79, 43, 138, 0.12), 0 4px 12px rgba(0, 0, 0, 0.05);
		display: flex;
		flex-direction: column;
		gap: 2.4vw;
	}

	.preview-item {
		width: 100%;
		max-width: 100%;
		overflow: hidden;
		border-radius: 3vw;
		line-height: 0;
	}

	.preview-img {
		display: block;
		width: 100% !important;
		max-width: 100% !important;
		height: auto !important;
		object-fit: contain;
		vertical-align: top;
	}

	.btmInfo {
		margin-top: 3.2vw;
		padding: 5vw 4.5vw;
		background: #fff;
		border-radius: 4.2vw;
		box-shadow: 0 10px 28px rgba(79, 43, 138, 0.12), 0 4px 12px rgba(0, 0, 0, 0.05);
	}

	.section-title {
		color: #2a1468;
		margin-bottom: 2.4vw;
		font-weight: 700;
		font-size: 4.2vw;
	}

	.section-body {
		color: #6a5a8f;
		font-size: 3.6vw;
		line-height: 1.65;
		white-space: pre-wrap;
	}
</style>
